import { useState } from 'react';

import { unwrapResult } from '@reduxjs/toolkit';
import format from 'date-fns/format';
import Alert from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDispatch } from 'react-redux';
import { Link, Redirect, useLocation } from 'react-router-dom';

import { ProductForm } from './forms/ProductForm';

import { updateProduct } from './productSlice';

export function ProductEdit() {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [alert, setAlert] = useState(null);

  if (!state) {
    return <Redirect to="/admin/product" />;
  }

  return (
    <Row className="justify-content-center">
      <Col md={4}>
        <h4>
          <Link to="/admin/product">Trở về</Link>
        </h4>
        <hr />
        <ProductForm
          alert={
            alert && <Alert variant={alert.variant}>{alert.content}</Alert>
          }
          disabled={{ productId: true }}
          onSubmit={async (data) => {
            setAlert(null);

            if (!data.installationDate || !data.installationDate) {
              return;
            }

            const installationDate = format(
              new Date(data.installationDate),
              'dd/MM/yyyy'
            );
            const warrantlyExpirationDate = format(
              new Date(data.warrantlyExpirationDate),
              'dd/MM/yyyy'
            );

            try {
              const result = await dispatch(
                updateProduct({
                  ...data,
                  productId: state.productId,
                  purchasedPrice: Number(data.purchasedPrice),
                  installationDate,
                  warrantlyExpirationDate,
                })
              );

              unwrapResult(result);
              setAlert({ variant: 'success', content: 'Thành công!' });
            } catch (e) {
              setAlert({ variant: 'danger', content: e.message });
            }
          }}
          values={{
            ...state,
            customerId: state.customer.customerId,
            installationDate: format(
              new Date(state.installationDate),
              'yyyy-MM-dd'
            ),
            warrantlyExpirationDate: format(
              new Date(state.warrantlyExpirationDate),
              'yyyy-MM-dd'
            ),
          }}
        />
      </Col>
    </Row>
  );
}
